var map = {
	"./allergies_96820810.json": 3174,
	"./allergies_96835965.json": 2864,
	"./allergies_dummy2.json": 9084,
	"./conditions_96820810.json": 7518,
	"./conditions_96835965.json": 4715,
	"./conditions_dummy2.json": 4615,
	"./diagnostic_reports_96820810.json": 5205,
	"./diagnostic_reports_96835965.json": 7752,
	"./diagnostic_reports_dummy2.json": 4635,
	"./medications_96820810.json": 4758,
	"./medications_96835965.json": 8851,
	"./medications_dummy2.json": 6012,
	"./nutrition_orders_96820810.json": 8928,
	"./nutrition_orders_96835965.json": 9153,
	"./nutrition_orders_dummy2.json": 5962,
	"./observations_96820810.json": 397,
	"./observations_96835965.json": 4960,
	"./observations_dummy2.json": 323,
	"./patient_96820810.json": 1145,
	"./patient_96835965.json": 8180,
	"./patient_dummy2.json": 6999,
	"./procedures_96820810.json": 8242,
	"./procedures_96835965.json": 8695,
	"./procedures_dummy2.json": 9040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;